import React, { useEffect, useState } from 'react';
import useUI from 'hooks/use-ui';
import { useSeoMenu } from './use-seo-menu';

/**
 * Client-only wrapper that runs the SEO menu hook.
 * This is separated to avoid useLayoutEffect SSR warnings from useApolloNetworkStatus.
 * TODO: Remove this once we have a better solution for Apollo Network Status.
 */
function SeoMenuClient(): null {
  useSeoMenu();
  return null;
}

export function SeoMenu({ children }: { children: JSX.Element }): JSX.Element {
  const [isMounted, setIsMounted] = useState(false);
  const { isIframe } = useUI();

  useEffect(() => {
    if (!isIframe) {
      return;
    }
    setIsMounted(true);
  }, [isIframe]);

  return (
    <>
      {isMounted && <SeoMenuClient />}
      {children}
    </>
  );
}
